import getCreditCardCriteria from "./get_credit_card_criteria";
import addTextToFeatureTable from "./add_text_to_feature_table";
import { doubleToStringMonthly } from "../../../objects/CommonUse/double_functions";

export const buildFeatureTextArr = (featureCriteria, gameNbrMonths, currentCash,
        savingsFound, monthlyIncome, creditReport, annualSalary, eligible) => {
    let featureTextArr = [];
    let featureCriteriaArr = [];
    let featureBulletText = "";
    let monthLit1 = " months."
    let monthLit2 = " months."
    if (featureCriteria.minNbrMonths === 1){
        monthLit1 = " month."
    }
    if (gameNbrMonths === 1){
        monthLit2 = " month."
    }
    featureBulletText = "Played the game for " + featureCriteria.minNbrMonths +  monthLit1 +
        " You have played the game for " + gameNbrMonths + monthLit2;
    eligible = addTextToFeatureTable(featureBulletText, "gameNbrMonths", featureCriteria.minNbrMonths, gameNbrMonths, 
        featureTextArr, featureCriteriaArr, eligible);
    featureBulletText = "Current cash must be at least " + 
        doubleToStringMonthly(featureCriteria.minCashAmt) + "." + 
        " You currently have " + doubleToStringMonthly(currentCash); 
    if (savingsFound === true){
        featureBulletText += " (including your short-term savings amount).";
    }else{
        featureBulletText += ".";
    }
    eligible = addTextToFeatureTable(featureBulletText, "currentCash", featureCriteria.minCashAmt, currentCash, 
        featureTextArr, featureCriteriaArr, eligible);
    featureBulletText = "Monthly Income must be at least " + 
        doubleToStringMonthly(featureCriteria.minMonthIncome) + "." +
        " Your current monthly income is " + doubleToStringMonthly(monthlyIncome) + 
        " (not including unplanned expenses).";
    eligible = addTextToFeatureTable(featureBulletText, "monthlyIncome", featureCriteria.minMonthIncome, 
        monthlyIncome, featureTextArr, featureCriteriaArr, eligible);
    if (featureCriteria.featureName === "creditCard"){
        eligible = getCreditCardCriteria(creditReport, featureCriteria, annualSalary, featureTextArr, 
            featureCriteriaArr, eligible);
    }
    const returnObj  = {featureTextArr: featureTextArr, featureCriteriaArr: featureCriteriaArr, eligible: eligible};
    return returnObj;
    
}
export default buildFeatureTextArr;